'use es6';

import { CommentObjectType, SUPPORTED_HUBS, FEATURES } from 'collaboration-sidebar';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { getSaveData, getCanSave } from './redux/selectors/saveSelectors';
import { getHasPermissionsToLoadEditor } from './redux/selectors/authSelectors';
import { autoSaveDebounced, autoSave, save } from './redux/actions/postSaveActions';
import PatagoniaHeader from './components/header/PatagoniaHeader';
import SidebarContainer from './containers/SidebarContainer';
import ExtraApplicationContainerComponents from './components/ExtraApplicationContainerComponents';
import RootTreeWrapper from './components/RootTreeWrapper';
import lang from 'i2l?query=sporks!blog-editor-ui/lang/en.lyaml';
import routes from './Routes';
import rootReducer from './redux/reducers';
import { asyncComponentsOverrides } from './components/AsyncComponents';
import { getAsyncComponents } from 'ContentEditorUI/components/AsyncComponents';
import { BLOG_API_BASE_URL } from './Constants';
import universalAppReadyMiddleware from 'ContentEditorUI/redux/middleware/universalAppReadyMiddleware';
import { mapStateToTinyMCEConfig } from './mapStateToTinyMCEConfig';
import { combinedInitialRequestThunk, contentAssistantThunk } from './redux/actions/requestThunks';
import { getStandardFetchCssRequestOptions } from 'ContentEditorUI/lib/scalableEditor/commonFeatureConfigs';
import fakeUndoRedoUpdates from './middleware/fakeUndoRedoUpdates';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { initialSidebarState } from 'ContentEditorUI/redux/reducers/sidebarStateReducer';
import { Map as ImmutableMap } from 'immutable';
import setupDevHelpers from './devHelpers';
import rhumbConfig from '../rhumb-config.yaml';
import ExtraApplicationContainerEditorWrapper from './components/ExtraApplicationContainerEditorWrapper';
import { ContentEditorCopilotCollaborationContextProvider } from 'ContentEditorUI/copilot/ContentEditorCopilotCollaborationContextProvider';
const makeInitialState = gates => {
  const isPatagonia = gates.includes('ContentEditorUI:PatagoniaRedesign');
  if (isPatagonia) {
    return null;
  }
  return {
    sidebarState: initialSidebarState.merge(ImmutableMap({
      activePanel: SIDEBAR_PANELS.addWidget,
      defaultPanel: SIDEBAR_PANELS.addWidget,
      sidebarCollapsed: false
    }))
  };
};
export const editorConfig = {
  // Passed to the renderer to locate where the request is coming from
  appKey: 'blog_post',
  appName: 'blog-editor-ui',
  features: {
    cssAssets: {
      getFetchCssRequestOptions: getStandardFetchCssRequestOptions
    },
    collaborationSidebar: {
      objectType: CommentObjectType.BLOG_POST,
      appHub: [SUPPORTED_HUBS.CMS_HUB, SUPPORTED_HUBS.MARKETING_HUB],
      appName: 'blog-editor',
      enabledFeatures: [FEATURES.COMMENTS, FEATURES.TASKS, FEATURES.CALENDAR]
    },
    templateTypes: true,
    shouldUseNopeZonesForAllModules: false,
    shouldFocusSingleStaticModule: false,
    hideLockedEditFormFields: true,
    checkUserAttributes: true,
    undoRedo: true,
    breakpoints: false,
    sections: false,
    smartContent: true,
    aiGeneratedContent: true,
    inlineStyles: true,
    quickSpot: false,
    copilotCollaboration: true,
    moduleInsertion: false
  },
  gatedFeatures: {
    copilotCollaboration: ['Chatspot:Widget:Beta', 'Copilot:Collaborate']
  },
  // Selectors required for the core app to work
  redux: {
    reducers: {
      rootReducer
    },
    selectors: {
      getSaveData,
      getCanSave,
      getHasPermissionsToLoadEditor
    },
    customMiddlewares: [fakeUndoRedoUpdates, NotificationMiddleware],
    actions: {
      autoSave,
      autoSaveDebounced,
      save
    },
    checkAppReadyMiddleware: universalAppReadyMiddleware(['FETCH_CONTENT_SCHEMA_SUCCEEDED', 'FETCH_MODULE_SCHEMAS_SUCCEEDED', 'GET_CONTENT_ASSISTANT_SETTINGS']),
    makeInitialState
  },
  components: {
    asyncComponents: getAsyncComponents(asyncComponentsOverrides),
    // TODO: These components may be evaluated too early because they are imported here
    // instead of further down the tree. Perhaps look at making them async or deferring the eval by
    // wrapping these in a function. The eval too early thing is probably leading to i18n not being ready. Try to remove i18n calls or find a way to defer them until render time inside these functions to see if that fixes things
    HeaderExtension: PatagoniaHeader,
    TabBarExtension: () => null,
    SidebarExtension: SidebarContainer,
    RootTreeWrapper,
    ExtraApplicationContainerComponents,
    ExtraApplicationContainerEditorWrapper,
    CopilotCollaborationContextProvider: ContentEditorCopilotCollaborationContextProvider
  },
  routes,
  infra: {
    rootUrl: '/blog/{portalId}/editor',
    rhumbConfig,
    lang
  },
  api: {
    API_BASE_URL: BLOG_API_BASE_URL,
    initialRequests: [combinedInitialRequestThunk, contentAssistantThunk]
  },
  mapStateToTinyMCEConfig,
  setupDevHelpers
};